module.exports = __webpack_public_path__ + "img/pf_logo.7d540688.svg";